module.exports = __webpack_public_path__ + "img/106058.9456f750.png";